module.exports = __webpack_public_path__ + "media/images/Branding/HW Vertical 2-1d3df160ced1313af7c93993d4cd4a2a.png";